<template>
  <v-card
    loader-height="8"
    :loading="admin.productsLoading"
    :disabled="admin.productsLoading"
    min-width="600"
    :min-height="minCardHeight"
  >
    <test-formula-dialog
      :show-dialog="showTestFormulaDialog"
      :formula="quantityFormula"
      @close="showTestFormulaDialog = $event"
      @updateFormula="updateFormula"
    ></test-formula-dialog>
    <copy-product-dialog
      :showDialog="showCopyDialog"
      :skuToCopy="admin.selectedProduct ? admin.selectedProduct.sku : null"
      :productIdToCopy="admin.selectedProduct ? admin.selectedProduct.id : 0"
      @close="showCopyDialog = $event"
      @selectProductId="emit('selectProductId', $event)"
      @showCopySuccess="showCopySuccess"
    />
    <v-toolbar color="blue darken-2" class="text-h4 text-uppercase" dark>
      {{ tabName }}
      <v-spacer></v-spacer>

      <v-icon>{{ app.productIcon }}</v-icon>
    </v-toolbar>
    <v-card-text v-show="admin.selectedProduct == null"></v-card-text>
    <v-card-text v-show="admin.selectedProduct != null">
      <v-overlay :opacity="0.9" absolute :value="showSaveOverlay">
        <v-btn color="success"> Product saved </v-btn>
      </v-overlay>
      <v-overlay :opacity="0.9" absolute :value="showCopyOverlay">
        <v-btn color="success"> Product copied </v-btn>
      </v-overlay>
      <v-form v-model="valid">
        <v-text-field v-model="id" label="ID" readonly></v-text-field>
        <v-text-field
          v-model="name"
          :rules="validation.length150"
          label="Product Name"
          required
          autofocus
        ></v-text-field>
        <v-text-field
          v-model="description"
          :rules="validation.length250"
          label="Product Description"
          required
        ></v-text-field>
        <v-textarea
          outlined
          v-model="longDescription"
          label="Long Description"
        ></v-textarea>
        <v-autocomplete
          :items="admin.productTypeList"
          label="Product Type"
          outlined
          item-text="name"
          item-value="id"
          v-model="productTypeId"
          :rules="validation.selection"
        ></v-autocomplete>
        <v-autocomplete
          :items="admin.sellAsTypeList"
          label="Sell As Type"
          outlined
          item-text="name"
          item-value="value"
          v-model="sellAsType"
        ></v-autocomplete>
        <v-autocomplete
          :items="admin.productList"
          label="Variant Of"
          outlined
          item-text="sku"
          item-value="id"
          v-model="variantOfProductId"
        >
          <template v-slot:item="data">
            {{ data.item.name }} ({{ data.item.sku }})
          </template>
          <template v-slot:selection="data">
            {{ data.item.name }} ({{ data.item.sku }})
          </template>
        </v-autocomplete>
        <v-text-field
          v-model="sku"
          :rules="validation.length50"
          label="SKU"
          required
        ></v-text-field>
        <v-text-field
          :disabled="sellAsType == 'Configured'"
          prepend-inner-icon="mdi-currency-usd"
          v-model="sellPrice"
          :rules="validation.numeric"
          label="Sell Price"
          required
        >
        </v-text-field>
        <v-textarea
          outlined
          clearable
          auto-grow
          v-model="quantityFormula"
          label="Quantity Formula"
          ><template v-slot:append-outer>
            <v-btn color="green" @click="showTestFormulaDialog = true">
              <v-icon>mdi-play</v-icon>Test
            </v-btn>
          </template></v-textarea
        >
        <v-text-field
          v-model="quantityFormulaDescription"
          label="Quantity Formula Description"
        ></v-text-field>
        <v-checkbox
          color="blue darken-2"
          v-model="published"
          label="Published"
        ></v-checkbox>
      </v-form>
    </v-card-text>
    <v-card-actions v-show="admin.selectedProduct != null">
      <v-btn dark color="blue darken-2" @click="copyProduct" :disabled="!valid"
        >copy</v-btn
      >
      <v-spacer />
      <v-btn dark color="blue darken-2" @click="saveProduct" :disabled="!valid"
        >save</v-btn
      >
      <v-btn color="gray" @click="cancelCreation">cancel</v-btn>
      <!-- <v-btn icon color="error" @click="confirmDeleteProduct"
        ><v-icon>mdi-trash-can</v-icon></v-btn
      > -->
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';
  import copyProductDialog from './CopyProductDialog.vue';
  import testFormulaDialog from './TestFormulaDialog.vue';

  export default {
    props: {
      minCardHeight: Number
    },
    components: { copyProductDialog, testFormulaDialog },
    data() {
      return {
        showSaveOverlay: false,
        showCopyOverlay: false,
        showConfirmDelete: false,
        showTestFormulaDialog: false,
        valid: false,
        showCopyDialog: false
      };
    },
    computed: {
      ...mapState(['app', 'admin']),
      tabName: {
        get() {
          let tabName = 'Edit Product';
          if (
            this.admin.selectedProduct &&
            this.admin.selectedProduct.id != 'new'
          ) {
            tabName = `Edit Product [${this.name.substring(0, 20)}${
              this.name.length > 20 ? '...' : ''
            }]`;
          } else if (
            this.admin.selectedProduct &&
            this.admin.selectedProduct.id == 'new'
          ) {
            tabName = 'Add New Product';
          }
          return tabName;
        }
      },
      id: {
        get() {
          return this.admin.selectedProduct?.id;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProduct',
            property: 'id',
            value: value
          });
        }
      },
      name: {
        get() {
          return this.admin.selectedProduct?.name;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProduct',
            property: 'name',
            value: value
          });
        }
      },
      description: {
        get() {
          return this.admin.selectedProduct?.description;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProduct',
            property: 'description',
            value: value
          });
        }
      },
      longDescription: {
        get() {
          return this.admin.selectedProduct?.longDescription;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProduct',
            property: 'longDescription',
            value: value
          });
        }
      },
      sku: {
        get() {
          return this.admin.selectedProduct?.sku;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProduct',
            property: 'sku',
            value: value
          });
        }
      },
      sellPrice: {
        get() {
          return this.admin.selectedProduct?.sellPrice;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProduct',
            property: 'sellPrice',
            value: isNaN(value) ? 0 : Number(value)
          });
        }
      },
      sellAsType: {
        get() {
          return this.admin.selectedProduct?.sellAsType;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProduct',
            property: 'sellAsType',
            value: value
          });
          if (value == 'Configured') {
            this.sellPrice = 0;
          }
        }
      },
      quantityFormula: {
        get() {
          return this.admin.selectedProduct?.quantityFormula;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProduct',
            property: 'quantityFormula',
            value: value
          });
        }
      },
      quantityFormulaDescription: {
        get() {
          return this.admin.selectedProduct?.quantityFormulaDescription;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProduct',
            property: 'quantityFormulaDescription',
            value: value
          });
        }
      },
      variantOfProductId: {
        get() {
          return this.admin.selectedProduct?.variantOfProductId;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProduct',
            property: 'variantOfProductId',
            value: value
          });
        }
      },
      productTypeId: {
        get() {
          return this.admin.selectedProduct?.productTypeId;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProduct',
            property: 'productTypeId',
            value: value
          });
        }
      },
      published: {
        get() {
          return this.admin.selectedProduct?.published;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedProduct',
            property: 'published',
            value: value
          });
        }
      }
    },
    methods: {
      /**
       * Updates the formula from the child dialog
       *
       * @param {*} val
       */
      updateFormula(val) {
        this.quantityFormula = val;
      },
      /**
       * Shows the copy success overlay
       */
      showCopySuccess() {
        this.showCopyOverlay = true;
        setTimeout(() => {
          this.showCopyOverlay = false;
        }, 2500);
      },
      /*
       * Copies the product currently being edited
       */
      copyProduct() {
        this.showCopyDialog = true;
      },
      /**
       * Cancels upsert of a product
       */
      cancelCreation() {
        this.$store.commit('admin/setSelectedProduct', null);
        this.$store.commit(
          'admin/setCurrentProductTab',
          this.admin.PRODUCT_TABS.LIST
        );
      },
      /**
       * Saves the product currently being edited
       */
      saveProduct() {
        this.$store.dispatch('admin/saveSelectedProduct').then(() => {
          this.showSaveOverlay = true;
          // refresh product list
          this.$store.dispatch('admin/getProductList');
          setTimeout(() => {
            this.showSaveOverlay = false;
          }, 1500);
        });
      }
    }
  };
</script>

<style scoped></style>
